import axios from "../plugins/axios";

export function getAnalystsWithPaymentInfo(params = {}) {
  return axios.get("/payments/analysts", { params });
}
export function getAnalystPaymentInfo(analystId, params = {}) {
  return axios.get(`/payments/analyst/${analystId}`, { params });
}
export function createPayment(data) {
  return axios.post("/payments", data);
}
export function getPayments(params = {}) {
  return axios.get("/payments", { params });
}
export const getPayment = (id) => axios.get(`/payment/${id}`);
export const updatePayment = (id, data) => axios.put(`/payment/${id}`, data);
export const removePaymentServices = (paymentId, serviceIds) =>
  axios.post("/payment/delete-services", { paymentId, serviceIds });
export const deletePayment = (id) => axios.delete(`/payments/${id}`);
